import {
    Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild, ViewEncapsulation
} from '@angular/core';
import {
    FormBuilder,
    FormGroup,
    NG_VALUE_ACCESSOR,
    Validators
} from '@angular/forms';
import { MatSelect } from '@angular/material';
import { EventTimeService } from '../../../services/event.time.service';
import { clone } from '../../extensions';
import * as moment from 'moment-timezone';

@Component({
    selector: 'ig-datetime-input',
    templateUrl: './datetime.input.component.html',
    styleUrls: ['./datetime.input.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class DateTimeInputComponent implements OnInit {
    @Input() public frequency: string;
    @Input() public startDate: Date;
    @Input() public endDate: Date;
    @Input() public disabled: boolean;
    @Input() public timezone: string;
    @Input() public timeFormatter: string;
    @Input() public allowNoTime = false;
    @Input() public isManualCreated = false;
    public startDatePrivate: Date;
    public endDatePrivate: Date;
    public dateTimeForm: FormGroup;
    public startTime = '19:0';
    public endTime = '22:0';
    public noTimeTip = '--None--';
    public today = new Date();
    @Output() change: EventEmitter<any> = new EventEmitter();
    @ViewChild('startSelect') public startSelect: MatSelect;
    @ViewChild('endSelect') public endSelect: MatSelect;
    public timeOptionsForStart = []
    public timeOptionsForEnd: any;
    public timeOptionsForTemp: any;

    constructor(private formBuilder: FormBuilder) {
    }

    public ngOnInit() {
        this.timeOptionsForStart = this.timeStep(15)
        this.dateTimeForm = this.formBuilder.group({
            time: [null, [Validators.required]],
            time2: [null, [Validators.required]],
        });

        if (this.allowNoTime) {
            this.startTime = 'no-time';
            this.endTime = 'no-time';
        }
        if (this.startDate && !this.endDate) {
            this.allowNoTime = true;
            this.endTime = 'no-time';
        }

        this.timeOptionsForEnd = clone(this.timeOptionsForStart);
        this.timeOptionsForTemp = clone(this.timeOptionsForStart);

        if (!this.timeFormatter && this.timezone) {
            this.timeFormatter = EventTimeService.getTimezoneFormatterByTimezone(this.timezone);
        }
        if (this.timeFormatter) {
            this.timezone = EventTimeService.getTimezoneCodeByFormatter(this.timeFormatter);
        }

        setTimeout(() => {
            let startTime = null;
            let endTime = null;
            let isoStartDate = null;
            let isoEndDate = null;
            let startDateWithTimezone;
            let endDateWithTimezone;
            //if (this.startDate && !this.allowNoTime) {
            if (this.startDate) {
                // let newStartDate = this.isManualCreated ? EventTimeService.adjustWithTimeSaving(this.startDate, this.timeFormatter, this.timezone) : null;
                let newStartDate = null;
                if (this.timeFormatter) {
                    startDateWithTimezone = EventTimeService.convertByTimezonFormatter(newStartDate || this.startDate, this.timeFormatter, false);
                }
                isoStartDate = startDateWithTimezone ? new Date(startDateWithTimezone).toISOString() : new Date(this.startDate).toISOString();
                let code = EventTimeService.toLocalDate(isoStartDate, this.timeFormatter);
                this.startDatePrivate = new Date(code);

                if (this.startTime !== 'no-time') {
                    startTime = EventTimeService.getTime(startDateWithTimezone || this.startDate);
                    this.startTime = startTime;
                    let modalMinute = startTime.split(':')[1];
                    let modalHour = startTime.split(':')[0];
                    let minInt = parseInt(modalMinute, 10);
                    if (minInt !== 30 && minInt !== 0) {
                        this.timeOptionsForStart = this.insertTime(modalHour, modalMinute);
                    }
                }
            }
            if (this.endDate) {
                // let newEndDate = this.isManualCreated ? EventTimeService.adjustWithTimeSaving(this.endDate, this.timeFormatter, this.timezone) : null;
                let newEndDate = null;
                if (this.timeFormatter) {
                    endDateWithTimezone = EventTimeService.convertByTimezonFormatter(newEndDate || this.endDate, this.timeFormatter, false);
                } else if (this.timezone) {
                    endDateWithTimezone = EventTimeService.convertToDateByTimezonCode(new Date(newEndDate || this.endDate).toISOString(), this.timezone);
                }
                endDateWithTimezone = this.processTimeForBrowsers(endDateWithTimezone);
                isoEndDate = endDateWithTimezone ? new Date(endDateWithTimezone).toISOString() : new Date(this.endDate).toISOString();
                let code = EventTimeService.toLocalDate(isoEndDate, this.timeFormatter);
                this.endDatePrivate = new Date(code);

                if (this.endTime !== 'no-time') {
                    endTime = EventTimeService.getTime(endDateWithTimezone || this.endDate);
                    this.endTime = endTime;
                    let modalMinute = endTime.split(':')[1];
                    let modalHour = endTime.split(':')[0];
                    let minInt = parseInt(modalMinute, 10);
                    if (minInt !== 30 && minInt !== 0) {
                        this.timeOptionsForEnd = this.insertTime(modalHour, modalMinute);
                    }
                }
            }
        });
    }

    public timeStep(step) {
        let date = new Date();
        date.setHours(0)
        date.setUTCMinutes(0)
        date.setSeconds(0)
        let stepNum = 24 * 60 / step
        let timeOptions = []
        for (let i = 0; i < stepNum; i++) {
            let time = new Date(Number(date.getTime()) + Number(step * i * 1000 * 60))
            let hour = '', min = '', value = '', text = ''
            hour = time.getHours() + ''
            min = time.getMinutes() + ''
            if (Number(hour) < 10) {
                hour = '0' + hour
            }
            if (Number(min) < 10) {
                min = '0' + min
            }
            value = hour + ":" + min
            if (Number(hour) < 10) {
                hour = hour.slice(1)
            }
            if (Number(hour) == 12) {
                text = hour + ":" + min + ' pm'
            } else {
                text = Number(hour) > 12 ? ((Number(hour) - 12) + ":" + min + ' pm') : (hour + ":" + min + ' am')
            }
            timeOptions.push({
                value: value,
                text: text
            })
        }
        return timeOptions
    }

    public dateChange($event, type) {
        this.setTime(type);
    }

    public setTime(type) {
        let dateTime = null;
        let date = type === 'start' ? moment(this.startDatePrivate).format('YYYY-MM-DD') : moment(this.endDatePrivate).format('YYYY-MM-DD');
        let time = type === 'start' ? this.startSelect.value : this.endSelect.value;
        time = time === 'no-time' ? '00:00' : time;
        date += " " + time;
        dateTime = moment.tz(date, this.timeFormatter).toISOString();
        if (type === 'start') {
            this.startDate = dateTime;
            if (this.endDatePrivate && this.startDatePrivate > this.endDatePrivate) {
                this.endDatePrivate = this.startDatePrivate;
                this.endDate = this.startDate;
            }
        } else if (type === 'end') {
            this.endDate = dateTime;
            if (this.startDatePrivate && this.startDatePrivate > this.endDatePrivate) {
                this.startDatePrivate = this.endDatePrivate;
                this.startDate = this.endDate;
            }
        }
        this.change.emit({ startTime: this.startDate, endTime: this.endDate });
    }

    private insertTime(modalHour, modalMinute) {
        let time = modalHour + ':' + modalMinute;
        let startIndex = 0;
        this.timeOptionsForTemp.forEach((x, index) => {
            let hourString = x.value.indexOf(':') !== -1 ? x.value.split(':')[0] : x.value;
            let hour = parseInt(hourString, 10);
            if (hour === modalHour) {
                if (modalMinute > 30) {
                    startIndex = index + 1;
                } else {
                    startIndex = index;
                }
            }
        });
        let temp = this.timeOptionsForTemp.slice(0, startIndex);
        let text = '';
        if (modalHour > 12) {
            text = (modalHour - 12) + ':' + modalMinute + ' pm';
        } else {
            text = time + ' am';
        }
        temp.push({ value: time, text: text });
        temp.push(...this.timeOptionsForTemp.slice(startIndex, this.timeOptionsForTemp.length));
        return temp;
    }

    private processTimeForBrowsers(time) {
        // try {
        //     new Date(time).toISOString();
        // } catch(err) {
        //     time = time.substr(0, time.lastIndexOf(' '));
        // }
        // return time;

        // return moment(time).toISOString();
        return time;
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/datetime.input/datetime.input.component.ts